import api from '../../api/cashoutRequests'

const socialpay = {
  qr: null,
  isLoading: false,
  error: null,
};

const qpay = {
  qr: null,
  logo: null,
  isLoading: false,
  url: null,
  error: null,
};

const nominal = {
  isLoading: false,
  error: null,
  code: null,
};


export default {
  namespaced: true,
  state: {
    qpay,
    socialpay,
    nominal
  },
  mutations: {
    SET_LOADER(state, { type, status }) {
      state[type].isLoading = status
    },
    SET_CODE(state, { type, status }) {
      state[type].code = status
    },
    SET_QR(state, { type, qr, logo, url }) {
      state[type].qr = qr
      if (logo) state[type].logo = logo
      if (url) state[type].url = url
    },
    SET_ERROR(state, { type, error }) {
      state[type].error = error
    },
    CLEAN_VALUES(state) {
      state.qpay = { ...qpay }
      state.socialpay = { ...socialpay }
      state.nominal = { ...nominal }
    }
  },
  actions: {
    async createNominalReq({ commit }, data) {
      const type = 'nominal'
      try {
        commit('SET_LOADER', { type, status: true })
        const { data: { code } } = await api.nominalPayment(data)
      } catch (e) {
        console.log('Nominal error:', e)
        commit('SET_ERROR', { type, error: e })
      } finally {
        commit('SET_LOADER', { type, status: false })
      }
    },
    async createQPayInvoice({ commit }, amount) {
      const type = 'qpay'
      try {
        commit('SET_LOADER', { type, status: true })
        const { data: { qr, logo, url } } = await api.generateQr(amount)
        commit('SET_QR', { type, qr, logo, url })
      } catch (e) {
        console.log('QR error:', e)
        commit('SET_ERROR', { type, error: e })
      } finally {
        commit('SET_LOADER', { type, status: false })
      }
    },
    async createQPayInvoiceLicense({ commit }, data) {
      const type = 'qpay'
      try {
        commit('SET_LOADER', { type, status: true })
        const { data: { qr, logo, url } } = await api.generateQrPayment(data)
        commit('SET_QR', { type, qr, logo, url })
      } catch (e) {
        console.log('QR error:', e)
        commit('SET_ERROR', { type, error: e })
      } finally {
        commit('SET_LOADER', { type, status: false })
      }
    },
    async createSocialPayQr({ commit }, amount) {
      const type = 'socialpay'
      try {
        commit('SET_LOADER', { type, status: true })
        const { data: { dl } } = await api.generateSocialPayQr(amount)
        commit('SET_QR', { type, qr: dl })
      } catch (e) {
        console.log(e)
        commit('SET_ERROR', { type, error: e })
      } finally {
        commit('SET_LOADER', { type, status: false })
      }
    },
    async createSocialPayQrLicense({ commit }, data) {
      const type = 'socialpay'
      try {
        commit('SET_LOADER', { type, status: true })
        const { data: { dl } } = await api.generateSocialPayQrPayment(data)
        commit('SET_QR', { type, qr: dl })
      } catch (e) {
        console.log(e)
        commit('SET_ERROR', { type, error: e })
      } finally {
        commit('SET_LOADER', { type, status: false })
      }
    },
    async clearValues({ commit }) {
      commit('CLEAN_VALUES')
    }
  },
}